import React from 'react';
import '../less';

export default function tpl() {
    const {platforms, isOpen} = this.state,
        {isHorizontal} = this.props,
        icons = platforms.map(iconName => (
            <div
                className={`icon ${iconName}`}
                key={iconName}
                onClick={() => this.handleIconClick(iconName)}
            />
        ));

    return isHorizontal ? (
        <div className="share-module horizontal">
            <div className="share-name">{this.l10n('NEWS_SHARE')}</div>
            {icons}
        </div>
    ) : (
        <div
            className="share-module"
            onMouseEnter={this.handleShareHover}
            onMouseLeave={this.handleShareHover}
            onClick={this.handleShareClick}
        >
            <div className="share icon"></div>
            <div className={`share__items ${isOpen ? 'active' : ''}`}>{icons}</div>
        </div>
    );
}
